<template>
  <div class="spliter">
    <div class="spliter-con">
      <!-- <multipane
        class="custom-resizer"
        layout="vertical"
      >
        <role-tree ref="box1" @selectedRole="selectedRole" />
        <multipane-resizer />
        <role-user-list ref="box2" 
          @selectedRoleUser="selectedRoleUser"
          @searchFilter="searchRoleUserList"
        />
      </multipane> -->
      <multipane
        class="custom-resizer"
        layout="vertical"
        @paneResize="paneResize"
        @paneResizeStop="paneresizeStop"
      >
      <div class="pane content-tree" ref="box1" id="box1" :class="treeWrap">
          <div class="ly-list tree-view">
            <div class="ly-list-top">
              <div class="ly-title">
                <h3 class="title-sub" v-show="!isToggle1">
                  {{ $t("messages.titCustomerTypeList") }}
                </h3>
                <el-button class="btn-toggle" @click="onTreeView()">
                  <i class="el-icon-arrow-right" v-if="isToggle1 == true"></i>
                  <i class="el-icon-arrow-left" v-else></i>
                </el-button>
              </div>
              <div class="ly-filter" v-show="!isToggle1">
                <idc-search-catalog
                  page="WORK"
                  :filterData="filterDataServiceCatalog"
                  :filterFormData="filterFormData"
                  @onSelectFilter="onSearchFilterTree"
                  :placeholder="$t('messages.plSearch')"
                  @filterServiceCatalogKeyword="getFilterKeyword"
                  ref="idcSearchTree"
                />
                <div class="ly-sort">
                  <div class="total">
                    <span>{{ $t("messages.all") }}</span>
                    <span class="total-num">{{ treeCount }}</span>
                  </div>
                  <div class="sort">
                    <!-- 체크 박스 아이콘 수정 -->
                    <!-- <el-button type="filter" class="icon icon-treeCheck" /> -->
                    <el-button type="filter" class="icon icon-treeOpen" />
                    <el-button type="filter" class="icon icon-treeClose" />
                  </div>
                </div>
              </div>
            </div>
            <div class="ly-list-content scrollY-auto" v-show="!isToggle1">
              <idc-tree
                :treeList="treeList"
                :defaultExpandAll="false"
                @node-click="handleTreeNodeClick"
                :showCheckbox="false"
                :defaultExpandedKeys="focusNodes"
                ref="tree"
              />
            </div>
          </div>
        </div>
        <multipane-resizer />
        <cust-user-list 
          ref="custUserSelectList"
          :custId="custId"
          @selectedCustMember="selectedCustMember"
        />
      </multipane>
    </div>
    <div class="dialog-footer align-r">
      <el-button type="primary" @click="selectCust">{{ $t("messages.btnSelectCust") }}</el-button>
      <el-button type="primary" @click="selectCustMember">{{ $t("messages.btnSelectCustMeber") }}</el-button>
      <el-button type="info" @click="closeRoleUserModal">{{ $t("messages.btnCancel") }}</el-button>
    </div>
  </div>
</template>

<script>
import commonMixin from "@/mixins/commonMixin";
import { Multipane, MultipaneResizer } from "vue-multipane";
import RoleTree from '@/components/systemMgComponents/RoleTree.vue';
import CustUserList from '@/components/listComponents/wrkComponents/CustUserList.vue';
import IdcSearchCatalog from "@/components/IdcSearchCatalog.vue";
import IdcTree from "@/components/common/IdcTree.vue";

export default {
  mixins: [commonMixin],
  components: {
    Multipane,
    MultipaneResizer,
    RoleTree,
    CustUserList,
    IdcSearchCatalog,
    IdcTree,
  },
  props:{
    keywordCheck:{
      value: Number,
      default: 0,
    },
    searchCustName:{
      value: String,
      default: ""
    },
    searchCustId:{
      value: String,
      default: ""
    },
  },
  data() {
    return {
      selectedCustMemberInfo:{},
      custId: "",
      custNm: "",
      treeViewIsTriggered: false,
      listViewIsTriggered: false,
      selectedCustInfo : {},
      selectedRoleUserInfo : {},
      treeList: [],
      focusNodes: [],
      filterDataServiceCatalog: {
        idc: "",
        service: "",
        name: "",
        state: "",
        ktBizUsgBngNthn: "",
        serviceNum: "",
        ktManager: "",
        industryType: "",
        ktManager: "",
        mine: "",
        lowTypeCtgCd: "",
      },
      filterFormData: {
        idcList: [
          {
            label: "전체",
            vaule: 1,
          },
        ],
        //TODO:이걸 콤보로? 확인 해봐야함.
        serviceLists: [
          {
            label: "전체",
            vaule: 1,
          },
        ],
        stateList: [
          {
            label: "전체",
            vaule: 1,
          },
          {
            label: "전체",
            vaule: 2,
          },
          {
            label: "전체",
            vaule: 3,
          },
        ],
        ktBizUsgBngNthnList: [
          {
            label: "전체",
            vaule: 1,
          },
          {
            label: "전체",
            vaule: 2,
          },
          {
            label: "전체",
            vaule: 3,
          },
        ],
        industryTypeList: [
          {
            label: "전체",
            vaule: 1,
          },
          {
            label: "전체",
            vaule: 2,
          },
          {
            label: "전체",
            vaule: 3,
          },
        ],
        typeList: [],
        subTypeList: [
        ],
      },
    }
  },
  mounted(){
    this.setComCd();
    this.getCustTreeList();
  },
  computed: {
    treeCount() {
      //console.log(this.treeList, 'this.treeList')
      let tmpCount = 0;
      this.treeList.map((data) => {
        if (data.hasOwnProperty("children")) {
          data.children.map((children) => {
            if (children.hasOwnProperty("children")) {
              if (!children.children) children.children = [];
              children.children.map(() => {
                tmpCount++;
              });
            }
          });
        }
      });
      return String(tmpCount).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  watch:{
    keywordCheck(){
      if(this.searchCustName != "" && this.searchCustName != null){
        this.$refs.idcSearchTree.filterKeyword = this.searchCustName;
      }else{
        this.$refs.idcSearchTree.filterKeyword = "";
      }
      this.getFilterKeyword("")
    }
  },
  methods: {
    async handleTreeNodeClick(node) {
      //console.log(node, 'nodeData~~~~~~~~')
      //계약목록 건수 초기화
      this.treeViewIsTriggered = true;
      if (node.parentId == "-1") {
        this.tpindTypeCd = "";
        this.custId = "";
        this.custNm = "";
      } /* else if (node.parentId == "0") {
        this.tpindTypeCd = node.id;
        this.custId = "";
        this.getLastChild(this.tpindTypeCd);
      } */ else {
        this.tpindTypeCd = "";
        this.custId = node.id;
        this.custNm = node.label;
        
        //구성원 목록으로 custId 전달 TO CustUserList.vue
        this.$EventBus.$emit("srCustId", this.custId);
        
      }
    },
    //idc콤보박스 세팅
    setIdcCdList() {
      let resData = [this.selectAllOption];
      //axios
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.getIdcCdList, {})
        .then((res) => {
          if (res.data !== "") {
            res.data.resData.map((data) => {
              resData.push({
                label: data.idcCdNm,
                value: data.idcCd,
              });
            });
          }
        })
        .catch((error) => {})
        .finally(() => {
          this.filterFormData.idcList = resData;
        });
    },
    onSearchFilterTree() {
      this.getCustTreeList();
    },
    getFilterKeyword(keyword) {
      if(this.searchCustName != "" && this.searchCustName != null){
        keyword = this.searchCustName;
      }
      this.$refs.tree.$refs.tree.filter(keyword);
    },
    filterGridKeyword(keyword) {
      this.filterTblText = keyword;
    },
    //공통콤보박스 세팅
    setComCdList(reqData, callback) {
      let resData = [this.selectAllOption];
      //axios
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.getCdList, reqData)
        .then((res) => {
          if (res.data !== "") {
            res.data.resData.map((data) => {
              resData.push({
                label: data.cdHnglNm,
                value: data.cd,
              });
            });
          } else {
            resData = [];
          }

          callback(resData);
        })
        .catch((error) => {})
        .finally(() => {});
    },
    //공통코드세팅
    setComCd() {
      this.setIdcCdList();
      //서비스
      this.setComCdList({ upCd: 1234 }, (resData) => {
        this.filterFormData.serviceLists = resData;
      });
      //상태
      this.setComCdList({ upCd: 1234 }, (resData) => {
        this.filterFormData.stateList = resData;
      });
      //KT사업용여부
      this.setComCdList({ upCd: 1234 }, (resData) => {
        this.filterFormData.ktBizUsgBngNthnList = resData;
      });
      //업종유형
      this.setComCdList({ upCd: 1591 }, (resData) => {
        this.filterFormData.industryTypeList = resData;
      });
    },
    getCustTreeList() {
      this.treeViewIsTriggered = false;
      this.listViewIsTriggered = false;

      this.isLoadingDetail = true;

      let reqData = {
        idcCd: this.filterDataServiceCatalog.idc, //idcCd
        svcTypeCd: this.filterDataServiceCatalog.service, //서비스유형
        custHnglNm: this.filterDataServiceCatalog.name, //고객명
        svcSttusCd: this.filterDataServiceCatalog.state, //상태
        ktBizUsgBngNthn: this.filterDataServiceCatalog.ktBizUsgBngNthn, //사업용유무
        svcNo: this.filterDataServiceCatalog.serviceNum, //서비스번호
        ktFlchrPrsnNm: this.filterDataServiceCatalog.ktManager, //전담자명
        tpindTypeCd: this.filterDataServiceCatalog.industryType, //업종유형
      };
      //axios
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Cus.getCustTreeList, reqData)
        .then((res) => {
          //console.log(res);
          if (res.data !== "") {
            this.treeList = res.data.resData;
            if (this.focusInfo) {
              this.setFocusNodes();
            }
          } else {
            this.treeList = [];
          }
        })
        .catch((error) => {})
        .finally(() => {
          setTimeout(() => {
            this.isLoadingDetail = false;
          }, 500);
          if(this.searchCustId != "" && this.searchCustId != null){
            this.setCustKeyWord();
            this.$EventBus.$emit("srCustId", this.searchCustId);
          }
        });
    },
    setCustKeyWord(){
    //SR 기본정보에서 선택한 고객사 데이터
      if(this.searchCustName != "" && this.searchCustName != null){
        if ( this.$refs.idcSearchTree) {
          this.$refs.idcSearchTree.filterKeyword = this.searchCustName;
        }
      }else{
        if ( this.$refs.idcSearchTree) {
          this.$refs.idcSearchTree.filterKeyword = "";
        }
      }
      this.getFilterKeyword("");
    },
    selectedRole(role) {
      this.selectedRoleInfo = role;
      this.$EventBus.$emit("selectedRole", this.selectedRoleInfo);
    },
    selectedRoleUser(roleUser) {
      this.selectedRoleUserInfo = roleUser;
    },
    searchRoleUserList(searchFilterData) {
      const roleId = this.selectedRoleInfo.roleId;
      if (!roleId) {
        alert('선택 된 권한 정보가 없습니다.');
        return;
      }
      this.getRoleUserList(roleId, searchFilterData);
    },
    resetData() {
      for(let i=0;i<this.$refs.tree.$refs.tree.store._getAllNodes().length;i++){
        this.$refs.tree.$refs.tree.store._getAllNodes()[i].expanded=false;
      }
      
      this.$refs.custUserSelectList.tableData = [];

      this.roleUserList = [];
      this.selectedRoleInfo = {};
      this.selectedRoleUserInfo = {};
    },
    closeRoleUserModal() {
      this.$emit("closeCustListModal");
      this.resetData();
    },
    selectCust() {
      if (Object.keys(this.custId).length <= 0) {
        alert('선택 된 고객사 정보가 없습니다.');
        return;
      } 
      //console.log(this.custId, 'this.custId');
      /* if (confirm("권한명 [" + this.selectedRoleInfo.roleNm + "] 을 선택 하시겠습니까?")) {
        this.$emit("selectedRoleUserInfo", this.selectedRoleInfo, {});
        this.resetData();
      } */
      this.selectedCustInfo = {
        custId : this.custId,
        custNm : this.custNm
      }
      this.$emit("selectedCustInfo", this.selectedCustInfo);
    },
    selectedCustMember(val){
      this.selectedCustMemberInfo = val;
    },
    selectCustMember() {
      if (Object.keys(this.selectedCustMemberInfo).length <= 0) {
        alert('선택 된 구성원 정보가 없습니다.');
        return;
      } 

      this.$emit("selectCustMember", this.selectedCustMemberInfo);

      /* if (confirm("권한명 [" + this.selectedRoleInfo.roleNm + "] 사용자명 [" + this.selectedRoleUserInfo.userNm + "] 을 선택 하시겠습니까?")) {
        this.$emit("selectedRoleUserInfo", this.selectedRoleInfo, this.selectedRoleUserInfo);     
        this.resetData();
      } */
    },
  }
}
</script>

<style lang="scss" scoped>
.button-container {
  margin-top: 20px;
}

.button-container.right {
  text-align: right;
}

.check-box-icon {
  border: 0;
}

.description-list li {
  list-style: inside;
  margin: 20px 0;
}

.table-flex {
  display: flex;
  flex-direction: column;
  li {
    line-height: 16px;
  }
}
.select-popup {
  height:300px;
}
.align-button-input {
  display:flex;
  justify-content: center;
  padding-bottom: 20px;
}
</style>